import { render, staticRenderFns } from "./Form4473Clean.vue?vue&type=template&id=bc81a5f6&scoped=true"
import script from "./Form4473Clean.vue?vue&type=script&lang=js"
export * from "./Form4473Clean.vue?vue&type=script&lang=js"
import style0 from "./Form4473Clean.vue?vue&type=style&index=0&id=bc81a5f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc81a5f6",
  null
  
)

export default component.exports